"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseError_1 = require("./BaseError");
var InvalidTypeError = /** @class */ (function (_super) {
    __extends(InvalidTypeError, _super);
    function InvalidTypeError(key, requiredType) {
        var _this = _super.call(this, InvalidTypeError) || this;
        var article = 'a';
        switch (requiredType.charAt(0)) {
            case 'a':
            case 'e':
            case 'i':
            case 'o':
            case 'u':
                article += 'n';
        }
        _this.message = "'" + key + "' has to be " + article + " '" + requiredType + "'";
        return _this;
    }
    return InvalidTypeError;
}(BaseError_1.BaseError));
exports.InvalidTypeError = InvalidTypeError;
